import angular from 'angular';

angular.module('cloudX').directive('cxDocumentTemplateSelect', [
  function() {
    return {
      restrict: 'E',
      template: `<a href="#" editable-select="value" onbeforesave="beforeSave($data)" e-ng-options="item.id as item.name for item in documentTemplates" edit-disabled="disabled" e-placeholder="{{'Use company setting'|translate}}">
        <span>{{getDisplayValue()}}</span>
        <span ng-show="!value">{{'Use company setting'|translate}}</span>
        <span ng-show="showMismatchWarning" title="{{('This template can normally not be selected. (Probably the wrong language)'|translate)}}"><i class="fa fa-exclamation-triangle text-warning"></i></span>
        </a>`,
      scope: {
        value: '=data',
        save: '&',
        languageCode: '@',
        templateType: '@',
        companyId: '@',
        disabled: '=',
      },
      controller: [
        '$scope',
        '$http',
        'appUrls',
        function($scope, $http, appUrls) {
          $scope.documentTemplates = [];
          $scope.showMismatchWarning = false;

          $scope.beforeSave = function(newValue) {
            if (newValue) {
              const documentTemplate = $scope.documentTemplates.find(x => x.id === newValue);
              $scope.showMismatchWarning = documentTemplate ? !!documentTemplate.isMismatch : true;
            } else {
              $scope.showMismatchWarning = false;
            }

            $scope.save({ newValue });
          };
          $scope.reloadTemplates = function() {
            return $http
              .get(`${appUrls.api}/api/documentTemplate/TemplatesForType`, {
                params: {
                  templateType: $scope.templateType,
                  languageCode: $scope.languageCode,
                  companyId: $scope.companyId,
                },
              })
              .then(function({ data }) {
                $scope.documentTemplates = data;

                if ($scope.value) {
                  const documentTemplate = data.find(x => x.id === $scope.value);
                  if (documentTemplate == null) {
                    $scope.showMismatchWarning = true;
                    $http
                      .get(`${appUrls.api}/api/documentTemplate/Templates`, {
                        params: {
                          templateType: $scope.templateType,
                          templateId: $scope.value,
                        },
                      })
                      .then(function({ data }) {
                        if (data && data.length) {
                          const template = data[0];
                          template.isMismatch = true;
                          $scope.documentTemplates.push(template);
                        }
                      });
                  } else {
                    $scope.showMismatchWarning = false;
                  }
                }
                return data;
              });
          };

          $scope.getDisplayValue = () => {
            if (!$scope.value || !$scope.documentTemplates) return null;
            const documentTemplate = $scope.documentTemplates.find(x => x.id === $scope.value);
            return documentTemplate ? documentTemplate.name : null;
          };
          $scope.$watchGroup(['languageCode', 'companyId'], function() {
            $scope.reloadTemplates();
          });
        },
      ],
    };
  },
]);
